import {colors, fontSize} from 'patient-ping-remedy/packages/theme';
import styled from '@emotion/styled';

type Props = {
  margin?: string;
  marginTop?: boolean;
  subtitle?: boolean;
}

const Header = styled.h1<Props>((props) => {
  const margin = props.margin || '2rem';

  return {
    fontSize: props.subtitle ? fontSize.heading : '2.4rem',
    margin: `${props.marginTop ? margin : 0} 0 ${margin} 0`,
    color: colors.primary1,
  };
});

export default Header;
